import { loadScriptInHead } from '../../utils/dom';

export default function Twitter() {
    //Twitter Widget (like in the header)
    const attrs = {
        id: 'twitter-wjs',
        'data-pin-custom': true
    };

    loadScriptInHead('statistics', 'https://platform.twitter.com/widgets.js', { attrs });

    //Twitter Univeral Tracking
    !function(e,t,n,s){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
    },s.version='1.1',s.queue=[]);}(window,document,'script');

    loadScriptInHead('statistics', 'https://static.ads-twitter.com/uwt.js');

    window.twq('config', 'o62x0');
}
